import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import { dataDecoding } from "../../helpers/serverEncoding";
import Chip from "@mui/material/Chip";
import actionGlobalConsultation from "../../actions/gobalConsultation";

import date from "../../js/date";

export default function TableConsultationResolved({ columns, rows, filter }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const { t } = useTranslation();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  return (
    <Paper
      sx={{ width: "100%", overflow: "hidden" }}
      elevation={3}
      style={{ borderRadius: "20px" }}
    >
      {/* <Grid container>

            </Grid> */}
      <TableContainer
        sx={{ maxHeight: 440, borderRadius: "20px" }}
        style={{ borderRadius: "20px", fontFamily: "Montserrat" }}
      >
        <Table
          stickyHeader
          aria-label="sticky table"
          style={{ borderRadius: "20px", fontFamily: "Montserrat" }}
        >
          <TableHead className="colcx-table">
            <TableRow className="colcx-table">
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align="center"
                  className="colcx-table-cell-header"
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(rows.length !== 0 &&
              rows
                .filter((ele) =>
                  filter && filter !== ""
                    ? ele.owner_name.includes(filter) ||
                      ele.project_name.includes(filter) ||
                      ele.project_code.includes(filter)
                    : true
                )
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={row.id}
                    style={{ fontFamily: "Montserrat" }}
                  >
                  <TableCell
                      align={"center"}
                      style={{ fontFamily: "Montserrat" }}
                    >
                      {row.project_code}
                    </TableCell>
                  <TableCell
                      align={"center"}
                      style={{ fontFamily: "Montserrat" }}
                    >
                      {dataDecoding(row.project_name)}
                    </TableCell>
                  <TableCell
                      align={"center"}
                      style={{ fontFamily: "Montserrat" }}
                    >
                      {row.qty}
                    </TableCell>
                  <TableCell
                      align={"center"}
                      style={{ fontFamily: "Montserrat" }}
                    >
                      {date.formatDateShort(row.start)}
                    </TableCell>
                  <TableCell
                      align={"center"}
                      style={{ fontFamily: "Montserrat" }}
                    >
                      {date.formatDateShort(row.end)}
                    </TableCell>
                  <TableCell
                      align={"center"}
                      style={{ fontFamily: "Montserrat" }}
                    >{row.url !== "" ? (
                      <IconButton aria-label="download" onClick={() => {window.open(row.url)}}>
                          <FileOpenIcon
                          />
                        </IconButton>
                    ) : (<></>)}
                      
                    </TableCell>
           
                  </TableRow>
                ))) || (
              <TableRow>
                <TableCell
                  align={"center"}
                  colSpan={columns.length}
                  style={{ fontFamily: "Montserrat" }}
                >
                  {t("globalConsultation.emptylist")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="d-flex w-100 justify-content-end">
        {/* Rows per page section */}
        <div className="d-flex align-items-center gap-2">
          <label
            htmlFor="rowsPerPage"
            className="mb-0 me-2 fw-semibold text-nowrap"
          >
            Rows per page:
          </label>
          <select
            id="rowsPerPage"
            className="form-select form-select-sm w-auto border-1 shadow-sm rows-per-page"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
          >
            {[25, 50, 100].map((rows) => {
              return <option value={rows}>{rows}</option>;
            })}
          </select>
        </div>
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={rows.length}
          style={{ fontFamily: "Montserrat" }}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            ".MuiTablePagination-displayedRows": {
              margin: 0,
            },
          }}
        />
      </div>
    </Paper>
  );
}
